import { createSelector } from '@reduxjs/toolkit'

import type { RootState } from '../../store'

import type { AuthSliceState } from './Auth.slice'

const selectAuth = (state: RootState) => state.auth

export const selectHasToken = createSelector(
  selectAuth,
  (authState: AuthSliceState) => authState.token !== undefined,
)
